<script lang="ts" setup>
import type { PageElementDataOfType } from '../page-builder'

const data = defineModel<PageElementDataOfType<'text'>>('data', {
  required: true,
})
</script>

<template>
  <RichTextInput v-model="data.text" :fix-height-to="128" minimal autofocus />
</template>
